// extracted by mini-css-extract-plugin
export default {"filtersContainerFullWidth":"SearchPageHeader_filtersContainerFullWidth__RGxn-","dynamicViewButton":"SearchPageHeader_dynamicViewButton__2Eib8"};